import { Spacing, Title } from '@vkontakte/vkui';
import coverImage from 'img/subscriptions/cancel-autorenew.png';
import React, { memo, ReactElement, useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { getFeatureFreezeAutoRenewal } from 'reactApp/modules/features/features.selectors';
import { ISubscription } from 'reactApp/modules/subscriptions/subscriptions.types';
import {
    ESubscriptionModalAction,
    useSendSubscriptionModalAnalytics,
} from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.analytics';
import { openFreezeRenewalModal } from 'reactApp/ui/FreezeRenewalModal/FreezeRenewalModal.helpers';

import styles from './CancelAutoRenewConfirmDialog.css';

interface IProps {
    leftQuota: string;
    onClose: () => void;
    onAction: () => void;
    onSuccess: () => void;
    isTrial: boolean;
    subscription: ISubscription;
}

export const CancelAutoRenewConfirmDialog = memo<IProps>(
    ({ leftQuota, onClose, onAction, onSuccess, isTrial, subscription }): ReactElement => {
        // tempexp_14269-start
        const freezeAutoRenewalEnabled = Boolean(useSelector(getFeatureFreezeAutoRenewal));
        const sendAnalytics = useSendSubscriptionModalAnalytics(subscription);

        useEffect(() => {
            if (freezeAutoRenewalEnabled) {
                sendAnalytics(ESubscriptionModalAction.freezeAutoRenewal);
            }
        }, []);

        // tempexp_14269-start
        const handleOnFreezeRenewalClick = useCallback(() => {
            openFreezeRenewalModal();
            sendAnalytics(ESubscriptionModalAction.freezeAutoRenewalClick);
        }, [sendAnalytics]);
        // tempexp_14269-end

        const content = useMemo(
            (): ReactElement => (
                <div className={styles.content}>
                    <Spacing size={12} />
                    <Title level="3">После {isTrial ? 'отмены' : 'окончания'} подписки:</Title>
                    <Spacing size={12} />
                    <ul className={styles.list}>
                        <li>Объём Облака уменьшится до {leftQuota}</li>
                        <li>Вернётся реклама</li>
                        <li>Не получится загружать тяжёлые файлы</li>
                    </ul>
                    <Spacing size={32} />
                </div>
            ),
            [isTrial, leftQuota]
        );

        return (
            <WhatsNewDialog
                onClose={onClose}
                onClick={onSuccess}
                onSecondary={onAction}
                primaryButtonText={isTrial ? 'Сохранить подписку' : 'Сохранить продление'}
                secondaryButtonText="Отменить"
                title="Вы уверены?"
                content={content}
                imageUrl={coverImage}
                imageBgColor="#ffffff"
                actionButtonText={freezeAutoRenewalEnabled ? 'Приостановить на 1 месяц' : undefined}
                onActionClick={handleOnFreezeRenewalClick}
            />
        );
    }
);

CancelAutoRenewConfirmDialog.displayName = 'CancelAutoRenewConfirmDialog';
